export function formatNumber(input: string | number): string {
  if (input === null || input === undefined || input === '') return '';

  const num = Number(input);
  if (isNaN(num)) return String(input);

  // Round to 2 decimals first
  const str = num.toFixed(2);

  // Split into integer + decimal
  const [intPart, decPart] = str.split('.');

  if (!decPart || Number(decPart) === 0) {
    // No decimals or decimals are all zero
    return intPart;
  }

  // Trim only *trailing* zeros from the decimal part
  return intPart + '.' + decPart.replace(/0+$/, '');
}
